<template>
  <g class="pipeline-node-end">
    <rect rx="13" height="26" width="45" y="-13" x="-12" class="circle-end"></rect>
    <text id="svg_2" x="-11" y="4" class="pipeline-node-end__text">{{label}}</text>
  </g>
</template>
<script>
export default {
  props: {
    label: {
      type: String
    }
  }
};
</script>

<style lang="css">
.pipeline-node-end .circle-end {
  stroke: none;
  fill: #aaa;
}

.pipeline-node-end__text {
  stroke: none;
  fill: #333;
  font-size: 12px;
}
</style>
